(function () {
    'use strict';

    $(document).ready(function () {
        const $subpage = $('.subpage');
        const $pages = $('.pages');

        // SOCIAL SHARING
        var $share = $('#share');
        $share.css('opacity', 1);
        $share.jsSocials({
            showLabel: false,
            showCount: false,
            shareIn: "popup",
            text: document.title,
            url: window.location.href,
            shares: [
                {
                    share: "facebook",
                    logo: `${$share.attr('data-templateURL')}/dist/images/facebook.svg`,
                    inlineSvg: true,
                },
                {
                    share: "twitter",
                    logo: `${$share.attr('data-templateURL')}/dist/images/twitter.svg`,
                    inlineSvg: true,
                    via: "PKN_ORLEN",
                },
                {
                    share: "linkedin",
                    logo: `${$share.attr('data-templateURL')}/dist/images/linkedin.svg`,
                    inlineSvg: true,
                }
            ]
        });

        $('.top h1.just-reveal').addClass('jr-running');

        setTimeout(function () {
            $('.top .breadcrumb-container ul.just-reveal').addClass('jr-running');
        }, 500);

        //tools show/hide
        $('#tools-toggle').click(function () {
            $('.tools-list').animate({
                height: 'toggle'
            });
            $(this).toggleClass('opened');
        });

        if ($(this).scrollTop() > 500) {
            $('aside.tools').addClass('scrolled');
        }

        if ($(this).scrollTop() > $(document).height() - 1600) {
            $('aside.tools').removeClass('scrolled');
        }

        $(window).on('scroll', function () {
            var top = $(this).scrollTop();
            var fullPageHeight = $(document).height();

            if (top > 500) {
                $('aside.tools').addClass('scrolled');
            } else {
                $('aside.tools').removeClass('scrolled');
            }

            if (top > fullPageHeight - 1600) {
                $('aside.tools').removeClass('scrolled');
            }
        });

        $('.share-page').on('click', function (e) {
            e.preventDefault();
            $('.sharing').fadeToggle();
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse').on('shown.bs.collapse', function (e) {
            updateTableSize();
            var positionTop = $(this).parent().offset().top; // - $('header').height();
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
            $(window).resize();
        });

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            updateTableSize();
        });

        // responsive image enlarging
        $('.popup-trigger').click(function (e) {
            $(this).parent().find('.popup-image-container').fadeIn();
            e.preventDefault();
            return false;
        });

        $('.popup-image-container').click(function () {
            $(this).fadeOut();
        });

        //Tooltipster

        // default tooltips
        $('.default-tooltipster').tooltipster({
            maxWidth: 290,
            contentAsHTML: true,
            interactive: true,
            // functionPosition: function (instance, helper, position) {
            //     console.log(instance, helper, position);
            //     if (!$(helper.origin).hasClass('center-tip')) {
            //         position.coord.left = helper.geo.origin.offset.left - 20;
            //     }
            //     return position;
            // },
        });

        $('.subpage .swiper-big-numbers').each(function (index) {
            var bigNumbersSwiper = new Swiper($(this)[0], {
                loop: false,
                direction: 'vertical',
                spaceBetween: 0,
                autoHeight: false,
                navigation: {
                    prevEl: '.swiper-big-numbers-button-prev',
                    nextEl: '.swiper-big-numbers-button-next',
                },

                breakpoints: {
                    767: {
                        allowTouchMove: false,
                    }
                }
            });
        });

        $('.subpage .swiper-quotation-slider').each(function (index) {
            var quotationsSwiper = new Swiper($(this)[0], {
                loop: false,
                spaceBetween: 0,
                autoHeight: true,
                navigation: {
                    prevEl: $(this).siblings('.swiper-quotation-button-prev'),
                    nextEl: $(this).siblings('.swiper-quotation-button-next'),
                },
            });
        });

        //Go top
        $('.subpage .go-top').click(function () {
            $('html, body').animate({
                scrollTop: 0
            }, 'slow');
            return false;
        });

        if ($(window).scrollTop() > 840) {
            $('.subpage .go-top').addClass('show');
        }

        $(window).scroll(function () {
            if ($(window).scrollTop() > 840) {
                $('.subpage .go-top').addClass('show');
            } else {
                $('.subpage .go-top').removeClass('show');
            }
        });

        function sendAnkieta() {

            var pytanie6ValuesArray = [];
            $.each($("input[name=Pytanie6]:checked"), function(){
                pytanie6ValuesArray.push($(this).val());
            });
            var pytanie6Values = pytanie6ValuesArray.toString();

            var today = new Date(),
                month = '' + (today.getMonth() + 1),
                day = '' + today.getDate(),
                year = today.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            var plainText = [year, month, day].join("");

            var ankietaData = {
                Token: btoa(plainText),
                Pytanie1: $('input[name=Pytanie1]:checked', '#ankieta-formularz').val(),
                Pytanie2: $('input[name=Pytanie2]:checked', '#ankieta-formularz').val(),
                Pytanie3a: $('input[name=Pytanie3a]:checked', '#ankieta-formularz').val(),
                Pytanie3b: $('input[name=Pytanie3b]:checked', '#ankieta-formularz').val(),
                Pytanie4: $('input[name=Pytanie4]', '#ankieta-formularz').val(),
                Pytanie5: $('input[name=Pytanie5]:checked', '#ankieta-formularz').val(),
                Pytanie6: pytanie6Values,
                Pytanie7: $('input[name=Pytanie7]:checked', '#ankieta-formularz').val(),
                Pytanie8: $('input[name=Pytanie8]:checked', '#ankieta-formularz').val()
            }

            $.ajax({
                url: "https://raportzintegrowany2019.orlen.pl/ank/api/OrlenSurvey",
                type: "POST",
                contentType: "application/json",
                timeout: 10000,
                data: JSON.stringify(ankietaData),
                success: function () {
                    $('.ajax-success').slideDown();
                    $("#ankieta-formularz").slideUp();
                    $("#ankieta-formularz").trigger("reset");
                },
                error: function () {
                    $('.ajax-error').slideDown();
                },
                beforeSend: function () {
                    $('.ajax-success').slideUp();
                    $('.ajax-loading').slideDown();
                    $('.ajax-error').slideUp();
                    $('.ajax-fill-required').slideUp();
                },
                complete: function () {
                    $('.ajax-loading').slideUp();
                },
            });
        }

        $('#ankieta-send').on('click', function (e) {
            e.preventDefault();
            var ankietaForm = document.getElementById('ankieta-formularz');
            if (ankietaForm.checkValidity() === false) {
                //ankietaForm.reportValidity();
                $('.ajax-fill-required').slideDown();
            } else {
                sendAnkieta();
            }
        });

        function updateTableSize() {
            $('.table-container').each(function () {
                if ($(this).parent().hasClass('panel-body')) return;
                var containerWidth = $(this).width();
                var tableWidth = $('table', this).width();

                if (tableWidth > containerWidth) {
                    $(this).addClass('scrollable');
                    $(this).mCustomScrollbar({
                        axis: "x",
                        mouseWheel: {
                            enable: true
                        }
                    });
                } else {
                    $(this).removeClass('scrollable');
                    $(this).mCustomScrollbar('destroy');
                }
            });
        }

        //Headlines navigation
        if ($subpage.length) {
            const $moveHeadline = $('.subpage .move-to-sidebar');
            const $sidebarContainer = $('.subpage aside.headlines-navigation');
            if ($moveHeadline.length) {
                // Setup Scrollmagic
                const controller = new ScrollMagic.Controller();
                const pinToTopDuration = $subpage.innerHeight() - $('.top').innerHeight() - 150 - 134;
                const headlinesData = []

                // Setup aside nav pin
                const pinToTopScene = new ScrollMagic.Scene({
                    triggerElement: '#headline-navigation',
                    triggerHook: 0,
                    duration: pinToTopDuration
                })
                .setPin('#headline-navigation')
                .addTo(controller);

                // Insert aside nav items
                $moveHeadline.each(function (index) {
                    const ID = $(this).attr('id');
                    const CONTENT = $(this).text().trim();

                    headlinesData.push({
                        a: `sidebar-${index}`,
                        headline: ID,
                    })

                    if (ID.length && CONTENT.length) {
                        $sidebarContainer
                            .find('ul')
                            .append(`<li><a href="#${ID}" class="scroll-animation" id="sidebar-${index}">${CONTENT}</a></li>`)
                    }
                })
                // Update pin removal after inserting aside nav items
                pinToTopScene.duration(pinToTopDuration - $sidebarContainer.innerHeight());

                // Setup aside nav items highlighting
                const lastIndex = $sidebarContainer.find('a.scroll-animation').length - 1;
                const lastScrollTop = $pages.length ? $pages.offset().top : $('footer').offset().top;
                const highlightSidebarScenes = [];

                // Function to update scenes pinToTopDuration (in case of window resizing)
                function updateHeadlinesTopOffsets() {
                    if (highlightSidebarScenes.length > 0) {
                        highlightSidebarScenes.forEach((scene, index) => {
                            const { headline } = headlinesData[index];
                            const scrollTop = $(`#${headline}`).offset().top;
                            let duration;
                            if (index < lastIndex)
                                duration = $(`#${headlinesData[index + 1].headline}`).offset().top - scrollTop
                            else
                                duration = lastScrollTop - scrollTop;

                            scene.duration(duration);
                        })
                    }
                }

                // Init aside nav items highlighting scenes
                $sidebarContainer.find('a.scroll-animation').each(function (index) {
                    const { a, headline } = headlinesData[index];
                    highlightSidebarScenes.push(
                        new ScrollMagic.Scene({
                            triggerElement: `#${headline}`,
                            triggerHook: 0.1
                        })
                            .setClassToggle(`#${a}`, 'active')
                            .addTo(controller)
                    )
                })
                updateHeadlinesTopOffsets();

                $(window).resize(function () {
                    pinToTopScene.duration($subpage.innerHeight() - $('.top').innerHeight() - 150 - 134 - $sidebarContainer.innerHeight());
                    updateHeadlinesTopOffsets()
                })
            } else {
                $sidebarContainer.remove();
            }
        }

    });
}(jQuery));
